<nav class='navigation'>
    <ul class="navigation-list">
        <li class="navigation-list-item" routerLink='/contact'><a href='#' routerLink='/contact' class="navigation-list-item-link" >Contact</a></li>
        <li class="navigation-list-item img"><img src="./assets/images/logo.svg" alt="" class="navigation-list-item-image"></li>
        <li class="navigation-list-item"><a href="./assets/files/Resume.pdf" download class="navigation-list-item-link">Resume</a></li>
    </ul>
</nav>
